import React, { useEffect, useState } from "react";
import {
  EMPTY_PLAN_FORM,
  PLAN_PRESETS,
  formatPlanSummary,
  presetToForm,
} from "../lib/planPresets";

export default function PlanEditor({ value, onChange, presetId: controlledPreset, onPresetChange }) {
  const [presetId, setPresetId] = useState(controlledPreset || "growth");

  useEffect(() => {
    if (controlledPreset != null) setPresetId(controlledPreset);
  }, [controlledPreset]);

  const handlePresetChange = (id) => {
    setPresetId(id);
    onPresetChange?.(id);
    if (id === "custom") return;
    const preset = PLAN_PRESETS.find((p) => p.id === id);
    if (preset) onChange(presetToForm(preset));
  };

  const onField = (field) => (e) => {
    const val = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    onChange({ ...value, [field]: val });
    if (presetId !== "custom") {
      setPresetId("custom");
      onPresetChange?.("custom");
    }
  };

  return (
    <div className="ops-plan-editor">
      <label>
        Plantilla de plan
        <select
          value={presetId}
          onChange={(e) => handlePresetChange(e.target.value)}
        >
          {PLAN_PRESETS.map((p) => (
            <option key={p.id} value={p.id}>
              {p.name} — {p.description}
            </option>
          ))}
          <option value="custom">Personalizado</option>
        </select>
      </label>

      <p className="ops-plan-preview">{formatPlanSummary(value)}</p>

      <div className="ops-form-grid">
        <label className="ops-toggle">
          <input type="checkbox" checked={!!value.arca_enabled} onChange={onField("arca_enabled")} />
          ARCA habilitado
        </label>
        <label className="ops-toggle">
          <input
            type="checkbox"
            checked={!!value.copilot_enabled}
            onChange={onField("copilot_enabled")}
          />
          Copilot habilitado
        </label>
        <label>
          Documentos / mes (vacío = ilimitado)
          <input
            type="number"
            value={value.max_documents_monthly}
            onChange={onField("max_documents_monthly")}
            placeholder="ej. 700"
          />
        </label>
        <label>
          Modelo tokens fallback
          <select value={value.fallback_tokens_model} onChange={onField("fallback_tokens_model")}>
            <option value="FLAT">FLAT (cupo incluido)</option>
            <option value="PAY_AS_YOU_GO">PAY_AS_YOU_GO</option>
          </select>
        </label>
        {value.fallback_tokens_model === "FLAT" && (
          <label>
            Tokens fallback incluidos
            <input
              type="number"
              value={value.fallback_tokens_included}
              onChange={onField("fallback_tokens_included")}
            />
          </label>
        )}
        <label>
          Fee mensual base (ARS)
          <input
            type="number"
            value={value.monthly_base_fee_ars}
            onChange={onField("monthly_base_fee_ars")}
          />
        </label>
        <label>
          Vigencia desde
          <input type="date" value={value.effective_from} onChange={onField("effective_from")} />
        </label>
      </div>
    </div>
  );
}

export { EMPTY_PLAN_FORM };
